<template>
    <div class="sticky-head" :class="{'no-scroll': !showScrollArrows}">
        <div class="scroll-arrows" v-show="showScrollArrows">
            <QuadArrowIcon @click="$emit('scrollTable', 'left')" class="left"/>
            <QuadArrowIcon @click="$emit('scrollTable', 'right')"/>
        </div>
        <div class="teacher-course-tables class-schedule-tables" v-if="!classViewSchedule">
            <table class="teachers">
                <thead>
                <tr>
                    <th class="scl-ad_tab-txt" :style="{'min-width': teacherLabelWidth+'px', 'height': '73px'}">{{ $t('teachers') }}</th>
                    <th class="scl-ad_tab-txt" :style="{'min-width': courseLabelWidth+'px', 'height': '73px'}">{{ $t('courses') }}</th>
                </tr>
                </thead>
            </table>
            <table class="schedule-teacher-course" ref="fixedHead">
                <thead>
                <tr>
                    <th v-for="(day,key) in days" :key="key" style="height: 73px">
                        <div class="day scl-ad_tab-txt">{{ day.name }}<br/>{{ `${datesOfWeek[key]}` }}</div>
                        <div class="shiftTime">
                            <span class="scl-ad_tab-txt" v-for="time in shiftTimes">{{ time.name }}</span>
                        </div>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="class-schedule-tables teacher-course-tables" v-if="classViewSchedule">
            <table class="class-name-table">
                <thead>
                <tr>
                    <th style="height: 73px">{{ $t('class') }}</th>
                </tr>
                </thead>
            </table>
            <table class="class-courses-table" ref="fixedHead">
                <thead>
                <tr>
                    <th v-for="(day,key1) in days" :key="key1">
                        <div class="day">{{ day.name }}<br/>{{ `${datesOfWeek[key1]}` }}</div>
                        <div class="shiftTime">
                            <span v-for="(time, key) in shiftTimes" :key="key">{{ time.name }}</span>
                        </div>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</template>

<script>
import QuadArrowIcon from '@/components/icons/QuadArrowIcon'

export default {
  components: {
    QuadArrowIcon
  },
  props: {
    days: Array,
    shiftTimes: Array,
    fixedTableWidth: Number,
    teacherLabelWidth: Number,
    classLabelWidth: Number,
    courseLabelWidth: Number,
    classViewSchedule: Boolean,
    showScrollArrows: Boolean,
    datesOfWeek: Array
  }
}
</script>

<style lang="scss">
    .sticky-head {
        position: sticky;
        top: 0;
        z-index: 5;
        background: #fff;
        border-radius: 5px 5px 0 0;
        &.no-scroll {
            background: none;
        }
    }
</style>
